import { createContext, useReducer } from 'react';

import { ProcessStep } from '../types';

import { IStateModel } from './types';

const initialState: IStateModel = {
  uploadData: {
    width: 0,
    height: 0,
    url: 'string',
  },
  errorMessage: null,
  fileData: {},
  processStep: ProcessStep.Upload,
};

function appReducer(state: IStateModel, action: { [key: string]: any } | null): IStateModel {
  return { ...state, ...action };
}

export const AppContext = createContext<{
  state: IStateModel;
  dispatch: React.Dispatch<any>;
}>({ state: initialState, dispatch: () => null });

export const AppProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};
